import React from 'react';
import { noop } from 'lodash';

import OtpFeature from '@features/otp';
import {
  useElearningWpRemoteResendOtp,
  useElearningWpRemoteVerifyOtp
} from '@services/elearning-wp-remote';

import { useElearningWpRemoteFlow } from './shared/ewr-flow-context';

function ElearningWpRemoteOtpPage() {
  const { goNext } = useElearningWpRemoteFlow();
  const { mutateAsync: verifyOtp, isPending } = useElearningWpRemoteVerifyOtp();
  const { mutateAsync: resendOtp, isPending: isResending } =
    useElearningWpRemoteResendOtp();

  return (
    <OtpFeature
      onVerify={(otp) => verifyOtp(otp).then(goNext).catch(noop)}
      onResend={() => resendOtp().then(() => {})}
      isPending={isPending}
      isResending={isResending}
    />
  );
}

export default ElearningWpRemoteOtpPage;
